import { Button, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import Table from "../../../../components/Table";
import Search from "../../../../components/Search";
import TrainingListForm from "./training-list-form/TrainingListForm";
import withRouter from "../../../../withRouter";
import LearningManagementPresenter from "./LearningManagementPresenter";

class TrainingListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LearningManagementPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      object: {},
      action: "",
      filteredStatus: "",
      trainings: [],
      filterTrainings: "",
      isTrainingFormOpen: false,
      formMode: "Add",
      count: 0,
      limit: 10,
      current: 1,
    };
  }
  async componentDidMount() {
    this.presenter.componentDidMount();
    const objects = await findObjectUseCase().execute("training_schedule");
    this.setState({ trainings: objects });
  }

  getCollectionName() {
    return "management_training";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  handleAddTraining() {
    this.setState({
      isTrainingFormOpen: true,
      object: {},
      action: "",
      formMode: "Add",
    });
  }

  async handleView(objectID) {
    // const objects = await findObjectUseCase().execute("management_training");
    // const object = objects.find((item) => item.id === objectID.id);
    // this.setState({ object, action: "view", isTrainingFormOpen: true });
    this.navigateTo(`/list/${this.getCollectionName()}/${objectID.id}`);
    console.log("OBJECTTIDDDD", objectID);
  }

  async handleEdit(objectID) {
    const objects = await findObjectUseCase().execute("management_training", {
      where: { id: objectID.id },
    });

    for (const object of objects) {
      this.setState({
        object,
        action: "edit",
        isTrainingFormOpen: true,
        formMode: "Edit",
      });
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, formMode, current, limit, count } = this.state;
    console.warn("OBEJCT: ", objects);
    if (!schema) return <Progress />;

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button onClick={this.handleAddTraining.bind(this)}>
                        <i className="bi bi-plus-lg" /> New Training
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectId={this.handleEdit.bind(this)}
                objectData={this.handleView.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                  {
                    label: <i className="bi bi-pencil-square"> Edit</i>,
                    actionType: "delete",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", "budgets", "costs"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isTrainingFormOpen && (
          <TrainingListForm
            closeTrainingForm={() =>
              this.setState({ isTrainingFormOpen: false })
            }
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
            action={this.state.action}
            formMode={formMode}
          />
        )}
      </>
    );
  }
}

export default withRouter(TrainingListPage);
